import { Head, Link, usePage, Deferred } from '@inertiajs/react'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Building2, MapPin, FileText } from "lucide-react"
import { DealsTable } from "@/components/deals-table"
import { VerticalTable } from "@/components/vertical-table"
import { Supplier } from '@/types/serializers'


interface Props {
  supplier: Supplier
  deals: any[]
}

export default function Show() {
  const { supplier, deals } = usePage<Props>().props

  return (
    <>
      <Head title={`Supplier: ${supplier.name}`} />
      <div className="">
        {/* Header with navigation and actions */}
        <div className="flex items-center justify-between border-b border-b-gray-100 p-4 mb-0">
          <div className="flex items-center space-x-4">
            <Link href="/suppliers">
              <Button variant="outline" size="icon">
                <ArrowLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">
                {supplier.name}
              </h1>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Link href={`/suppliers/${supplier.id}/edit`}>
              <Button variant="outline" className="flex items-center space-x-2">
                <FileText className="h-4 w-4" />
                <span>Edit</span>
              </Button>
            </Link>
          </div>
        </div>

        {/* Main content */}
        <div className="">
          <div className="grid grid-cols-1 md:grid-cols-4 min-h-screen">
            {/* Main content area - with deals table */}
            <div className="md:col-span-3">
              <Deferred data="deals" fallback={<div>Loading...</div>}>
                <DealsTable
                  title='Deals'
                  showActions={false}
                  hiddenColumns={["supplier.name"]}
                />
              </Deferred>
            </div>

            {/* Right sidebar with supplier information */}
            <div className="space-y-6 p-6 bg-gray-50/50 border-l border-l-gray-100 p-4 md:col-span-1 min-h-full">
              {/* Basic Information Card */}
              <VerticalTable
                title="Basic Information"
                icon={Building2}
                rows={[
                  { key: "Name", value: supplier.name },
                  { key: "Created", value: new Date(supplier.created_at).toLocaleDateString() },
                  { key: "Updated", value: new Date(supplier.updated_at).toLocaleDateString() }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
